import {createInternationalizationPrefixer, getCurrentLanguage} from "../../platform/i18n/i18n";
import React, {useState} from "react";
import AjaxService from "../../platform/ajax/AjaxService";
import {OptiselModal} from "../../components/modal/OptiselModal";
import UboldSpinner from "../../ubold-components/UboldSpinner";
import {LATEST_OPTISEL_VERSION} from "../../components/Changelog";

const t = createInternationalizationPrefixer("OrderInquiry");

export function OrderViaDatasheetButtonWithEmbeddedModal(props: { memoizedDatasheetId: string }) {
    const {modalElement, standardOrderButtonElement} = useOrderInquiryForMemoizedDatasheet(props.memoizedDatasheetId, LATEST_OPTISEL_VERSION, getCurrentLanguage());
    return <>
        {standardOrderButtonElement}
        {modalElement}
    </>;
}

export function useOrderInquiryForMemoizedDatasheet(memoizedDatasheetId: string, appVersion: string, userLanguage: string) {
    const [orderDescription, setOrderDescription] = useState("");
    const [state, setState] = useState<"closed" | "form" | "sending" | "done">("closed");

    const processSubmissionWithModalLifecycle = async () => {
        setState("sending");
        try {
            await sendOrderInquiry({
                memoizedDatasheetId,
                orderDescription: orderDescription,
                applicationVersion: appVersion,
                userLanguage: userLanguage
            });
            setState("done");
        } catch (e) {
            alert("Sorry, failed to send inquiry. Please try again later.");
            setState("closed");
        }
    }

    const formElement = <div className="text-center">
        <p>{t('Komentarz do zapytania')}</p>
        <p className={"text-gray-400"}>{t('Karta wentylatora zostanie załączona automatycznie.')}</p>
        <textarea className="my-3 w-100 form-control min-h-375px" value={orderDescription} onChange={(e) => setOrderDescription(e.target.value)}/>
        <div className={"d-flex flex-row gap-3 justify-content-center"}>
            <button className="btn btn-primary" onClick={processSubmissionWithModalLifecycle}>{t('Wyślij zapytanie')}</button>
            <button className="btn btn-warning" onClick={() => setState("closed")}>{t('Anuluj')}</button>
        </div>
    </div>;

    const modalElement = <OptiselModal header={t('Wyślij zapytanie')} opened={state !== "closed"} closeable={false} onClose={() => setState("closed")}>
        {state === "form" && formElement}
        {state === "sending" && <UboldSpinner/>}
        {state === "done" && <div className={"d-flex justify-content-center flex-column"}><p>{t('Dziękujemy, zapytanie zostało wysłane.')}</p><button className="btn btn-primary" onClick={() => setState("closed")}>{t('OK')}</button></div>}
    </OptiselModal>;

    const openOrderDialog = () => {
        setOrderDescription("");
        setState("form");
    };

    const standardOrderButtonElement = <button className="btn btn-sm btn-light me-3" onClick={openOrderDialog}>
        <div className={"mb-1 mt-2"}><i className="far fa-envelope fs-1"></i></div>
        {t("Zapytanie")}
    </button>;

    return {
        standardOrderButtonElement,
        modalElement
    }
}

interface NewOrderDetailsJson {
    memoizedDatasheetId: string;
    orderDescription: string;
    applicationVersion: string;
    userLanguage: string;
}

function sendOrderInquiry(newOrderDetails: NewOrderDetailsJson) {
    return AjaxService.postJson("/api/send-inquiry-order", newOrderDetails);
}